import { COUNTRIES } from '../../constants/country';
import { getCurrentCountry } from '../../utils/country';
import { parseDate } from '../../utils/date';

const DAY_MONTH_YEAR = {
  mask: [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/],
  mode: 'numeric',
  type: 'text',
};

export const DATE_VALIDATION = {
  [COUNTRIES.FR]: {
    inputConfig: DAY_MONTH_YEAR,
  },
  [COUNTRIES.GB]: {
    inputConfig: DAY_MONTH_YEAR,
  },
};

const getLocaleDateValidation = () => DATE_VALIDATION[getCurrentCountry()];

export const getDateInputConfig = () => getLocaleDateValidation().inputConfig;

export const isValidDate = (value?: string) => {
  if (!value) return false;

  const date = parseDate(value);
  return date && date.isValid();
};
